import { Component } from 'react';
import { useSearchParams } from 'react-router-dom'

import './App.css';




var Views = {}
var comps = require.context('./views', false, /.*/)
comps.keys().forEach((item) => {
	Views[item.replace('./', '').split('.')[0]] = comps(item).default
})

var lastview = ""
var img = {}
var imgs = require.context('./img', false, /.*/)
imgs.keys().forEach((item) => {
	img[item.replace('./', '').split('.')[0]] = imgs(item)
})


class App extends Component {

	constructor(props) {
		super(props)
		this.state = {
			loggedIn: false,
			twoFactorConfirmed: false,
			view: "Landing",
			data: {
				MMISorLIC: "M",
				RequestDate: new Date().toISOString(),
				EffectiveDate: new Date().toISOString(),
				Profession_Code: "  "
			}
		}
	}
	navigate(view) {
		var payload = Object.assign({}, this.state)
		payload.view = view
		payload.lastview = lastview
		console.log(this.props.data);
		fetch(window.location.origin + window.location.pathname + 'checkalignment', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify(payload) }).then(async (response) => {
			if (response.status == 200) {
				if (view) {
					window.location.hash = view;
					this.setState({ view: window.location.hash.replace('#', '') })
				} else {
					this.navigate('Landing')
				}
			} else {
				console.log("Session expired")
				this.setState({ loggedIn: false, twoFactorConfirmed: false, data: {}, view: 'Landing' })
			}
		})
		console.log("Navigating to " + view);
		console.log("Last View " + lastview);

		if (lastview != view) {
			fetch(window.location.origin + window.location.pathname + 'logUserAction',
				{
					method: 'POST',
					headers: { "Content-Type": 'application/json' },
					body: JSON.stringify(payload)
				}
			).then((response) => {
				console.log(response)
			})
		}
		lastview = view

	}
	login(userData) {
		window.location.hash = this.state.view;
		this.setState({ loggedIn: true, data: userData })
	}
	confirmTwoFactor(userData) {
		this.setState({ twoFactorConfirmed: true, data: userData })
	}
	logOut = (e) => {
		var payload = Object.assign({}, this.state)
		fetch(window.location.origin + window.location.pathname + 'logout', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify(payload) }).then(async (response) => {
			this.setState({ loggedIn: false, twoFactorConfirmed: false, data: {}, view: 'Landing' })
		})

	}
	startOver = (e) => {
		var payload = Object.assign({}, this.state)
		fetch(window.location.origin + window.location.pathname + 'startOver', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify(payload) }).then(async (response) => {
			if (response.status == 200) {
				var newData = await response.json()
				console.log(newData)
				this.setState({ loggedIn: true, twoFactorConfirmed: true, data: newData, view: 'Landing' })
				window.location.hash = 'Landing';
				this.setState({ view: 'Landing' })

			} else {
				console.log("Session expired")
				this.setState({ loggedIn: false, twoFactorConfirmed: false, data: {}, view: 'Landing' })
				window.location.hash = 'Landing';
				this.setState({ view: 'Landing' })
			}

		})

	}
	register() {
		console.log("yo")
		window.location.hash = 'Register'
		this.setState({ registering: {}, view: 'Register' })
	}
	reset = () => {
		console.log("Resetting Password")
		window.location.hash = 'Reset'
		this.setState({ reset: {}, view: 'Reset' })
	}


	completeRegistration() {
		var newData = Object.assign({}, this.state.data)
		newData["Participant Type"] = this.state.registering["Participant Type"]
		newData.NPI = this.state.registering.NPI
		newData.Prescriber_ID = this.state.registering.NPI
		newData.FirstName = this.state.registering.FirstName
		newData.LastName = this.state.registering.LastName
		newData.Email = this.state.registering.Email
		newData.Phone = this.state.registering.Phone
		this.setState({ data: newData, registering: false, twoFactorConfirmed: true, view: 'Landing', loggedIn: true }, () => window.location.hash = 'Landing')
		this.startOver()
	}
	cancelRegister = () => {
		this.setState({ registering: false, twoFactorConfirmed: false, loggedIn: false }, () => {
			this.navigate('Landing')
		})
	}
	cancelReset = () => {
		this.setState({ reset: false, twoFactorConfirmed: false, loggedIn: false }, () => {
			window.location.search = '';
			this.navigate('Landing')
			window.location.hash = 'Landing'
		})
	}

	hashNavigate(view) {
		this.navigate(window.location.hash.replace('#', ''))
	}
	setResetData(variable, value) {
		var reset = Object.assign({}, this.state.reset)
		reset[variable] = value
		this.setState({ reset: reset })
	}

	setData(variable, value) {
		var newData = Object.assign({}, this.state.data)
		newData[variable] = value
		this.setState({ data: newData })
	}
	setRegisterData(variable, value) {
		var register = Object.assign({}, this.state.registering)
		register[variable] = value

		this.setState({ registering: register })
	}
	componentDidMount() {

		console.log("Reset Page Loaded")
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		var QueryStringData = {};
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			//Add Result to state
			QueryStringData[pair[0]] = pair[1];
		}
		if (QueryStringData.token) {
			fetch(window.location.origin + window.location.pathname + 'checkResetToken', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ token: QueryStringData.token }) }).then(async (response) => {
				if (response.status == 200) {
					console.log(QueryStringData.token)
					this.setState({ reset: { token: QueryStringData.token, response: "valid" }, view: 'Reset' })
				} else {
					console.log(QueryStringData.token)
					this.setState({ reset: { token: QueryStringData.token, response: "invalid" }, view: 'Reset' })
				}
			})
		}
		//window.addEventListener("hashchange", this.hashNavigate.bind(this), false);
	}
	//https://dme-dev.dirad.cloud/portal/?reset=true&code=bd9836e393a528991c028c048114adc184c9e9affc4a2c7d794d907bc59dc84e



	render() {

		var ViewType = Views[window.location.hash ? window.location.hash.replace('#', '') : 'Landing']
		if (this.state.reset) {
			ViewType = Views.Reset
			return (
				<div className="App">
					<div className="backdrop"></div>
					<div className="box" >
						<ViewType img={img} data={this.state.reset} navigate={this.navigate.bind(this)} setResetData={this.setResetData.bind(this)} />
						{window.location.hash.replace('#', '') != "Landing" ? <div className="button" style={{ backgroundColor: '#888' }} onClick={this.cancelReset}>Return to Login</div> : ""}
					</div>
				</div>
			);
		} else if (this.state.registering) {
			ViewType = Views.Register
			return (
				<div className="App">
					<div className="backdrop"></div>
					<div className="box" >
						<ViewType img={img} data={this.state.registering} completeRegistration={this.completeRegistration.bind(this)} navigate={this.navigate.bind(this)} setRegisterData={this.setRegisterData.bind(this)} />
						{window.location.hash.replace('#', '') != "Landing" ? <div className="button" style={{ backgroundColor: '#888' }} onClick={this.cancelRegister}>Return to Login</div> : ""}
					</div>
				</div>
			);
		} else if (!this.state.loggedIn) {
			ViewType = Views.Login
			return (
				<div className="App">
					<div className="backdrop"></div>
					<div className="box" >
						<ViewType img={img} data={this.state.data} navigate={this.navigate.bind(this)} login={this.login.bind(this)} register={this.register.bind(this)} reset={this.reset.bind(this)} setData={this.setData.bind(this)} />
					</div>
				</div>
			);
		} else if (!this.state.twoFactorConfirmed) {
			ViewType = Views.TwoFactor
			return (
				<div className="App">
					<div className="backdrop"></div>
					<div className="box" >
						<ViewType img={img} data={this.state.data} confirmTwoFactor={this.confirmTwoFactor.bind(this)} login={this.login.bind(this)} register={this.register.bind(this)} setData={this.setData.bind(this)} />
						<div className="button" style={{ backgroundColor: '#888' }} onClick={this.cancelRegister}>Return to Login</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className="App">
					<div className="backdrop"></div>
					<div className="box" >
						<ViewType img={img} data={this.state.data} navigate={this.navigate.bind(this)} setData={this.setData.bind(this)} />
						{window.location.hash.replace('#', '') != "Landing" ? <div className="button" style={{ backgroundColor: '#888' }} onClick={() => this.startOver()}>Start Over</div> : ""}
						<div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', top: '15px', left: '15px', width: 'calc(100% - 30px)' }}><div style={{ cursor: 'pointer' }}>{this.state.data["Participant Type"] + ': ' + (this.state.data["Participant Type"] == 'Prescriber' ? this.state.data.NPI : this.state.data.NPI)}</div><div onClick={this.logOut} style={{ cursor: 'pointer' }}>Logout</div></div>
					</div>
				</div>
			);
		}






	}
}

export default App;
